// Как показывать вводные тексты разделов. Храним в cookie, а не в localStorage:
// сервер читает cookie сразу и рисует блок в нужном состоянии — без мигания
// и расхождений гидратации, которые дал бы localStorage (на сервере его нет).

const YEAR = 60 * 60 * 24 * 365;
const cookieOptions = { maxAge: YEAR, sameSite: "lax" as const, path: "/" };

// Глобально скрыть описания во всех разделах. Флаг посетителя — поисковик
// cookie не присылает и видит описания как обычно
export const useHideIntro = () =>
  useCookie<boolean>("intro_hidden", { default: () => false, ...cookieOptions });

// Свёрнутые описания по разделам: { alias: true }. Храним отклонение от
// умолчания (на десктопе текст развёрнут, на телефоне свёрнут), поэтому в
// карте оказываются только те разделы, где посетитель сам переключил
export const useIntroCollapsed = () =>
  useCookie<Record<string, boolean>>("intro_collapsed", {
    default: () => ({}),
    ...cookieOptions,
  });
